import { ValidationUtility } from "../../../validation-utility";
import { IValidatorType } from "../../../validator-interface";

export interface ICreateAPIKeyRequest {
	communityId: string
}

export const VCreateAPIKey: IValidatorType<ICreateAPIKeyRequest> = {
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: false },
}

export interface ICreateAPIRKeyesponse {

}

export interface IGetAPIKeyRequest {
	communityId: string
}

export const VGetAPIKey: IValidatorType<IGetAPIKeyRequest> = {
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: true },
}

export interface IGetAPIKeyResponse {
	apiKey?: string | null;
}

export interface IDeleteAPIKeyRequest {
	communityId: string
}

export const VDeleteAPIKey: IValidatorType<IDeleteAPIKeyRequest> = {
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: true },
}
